var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFrancSign(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M128 112V192H248C270.094 192 288 209.906 288 232S270.094 272 248 272H128V320H192C209.688 320 224 334.328 224 352S209.688 384 192 384H128V440C128 462.094 110.094 480 88 480S48 462.094 48 440V384H32C14.312 384 0 369.672 0 352S14.312 320 32 320H48V72C48 49.906 65.906 32 88 32H280C302.094 32 320 49.906 320 72S302.094 112 280 112H128Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrancSign);
export default __webpack_public_path__ + "static/media/franc-sign.939d3a3e9a972e02169b9514e207ec64.svg";
export { ForwardRef as ReactComponent };